// Shared constants for all 3D voxel components (icons + donut)
// Extracted from CubeIcon/HowItWorks — change here to update everywhere

export const CUBE_SIZE: [number, number, number] = [0.25, 0.25, 0.25];
export const CUBE_RADIUS = 0.04;
export const CUBE_SMOOTHNESS = 3;
export const CUBE_GAP = 0.25; // spacing between cube centers

export const CUBE_MATERIAL_PROPS = {
  metalness: 0.05,
  roughness: 0.3,
  clearcoat: 0.6,
  clearcoatRoughness: 0.2,
  envMapIntensity: 0,
  reflectivity: 0.4,
  toneMapped: false,
} as const;
